import store from '../../store'
import {archiveMeeting} from '../../actions/meetings'

export function deleteMeeting(meetingId,docId,history) {
	if(history){
		history.push('/meetings')
	}
	store.dispatch(archiveMeeting(meetingId,docId))
}
